import { render, staticRenderFns } from "./HkiaraceReport.vue?vue&type=template&id=c71b5dcc"
import script from "./HkiaraceReport.vue?vue&type=script&lang=js"
export * from "./HkiaraceReport.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceReport.vue?vue&type=style&index=0&id=c71b5dcc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports